import type { ButtonHTMLAttributes, ReactNode } from 'react';
import {
  BUTTON_BASE,
  BUTTON_SIZES,
  BUTTON_VARIANTS,
  PRIMARY_BG,
  type ButtonSize,
  type ButtonVariant,
} from './buttonStyles.ts';

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  loading?: boolean;
  children: ReactNode;
};

export function Btn({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled,
  children,
  className = '',
  style,
  type,
  ...rest
}: Props) {
  const variantStyle = variant === 'primary' ? { backgroundColor: PRIMARY_BG, ...style } : style;
  return (
    <button
      type={type ?? 'button'}
      disabled={disabled || loading}
      className={`${BUTTON_BASE} ${BUTTON_SIZES[size]} ${BUTTON_VARIANTS[variant]} ${className}`}
      style={variantStyle}
      {...rest}
    >
      {loading && (
        <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none">
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeOpacity=".25"
            strokeWidth="4"
          />
          <path d="M4 12a8 8 0 018-8" stroke="currentColor" strokeWidth="4" strokeLinecap="round" />
        </svg>
      )}
      {children}
    </button>
  );
}
